<div class="min-h-screen pb-12 bg-gray-50">
  <main class="w-full px-4 sm:px-6 lg:px-8 py-8">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex flex-col justify-center items-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4"></div>
      <p class="text-gray-600">Cargando perfil del estudiante...</p>
    </div>

    <!-- Profile Content -->
    <div *ngIf="!isLoading && profile" class="space-y-6">

      <!-- Header Section -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
        <div class="flex flex-col lg:flex-row justify-between items-start gap-6">
          <div class="flex items-start gap-5 flex-1 min-w-0">
            <!-- Avatar -->
            <div
              class="h-20 w-20 rounded-full bg-indigo-50 border-2 border-indigo-100 flex items-center justify-center flex-shrink-0">
              <span class="text-2xl font-bold text-indigo-600">
                {{ (profile.participant.firstName?.charAt(0) || '') + (profile.participant.lastName?.charAt(0) || '') }}
              </span>
            </div>

            <!-- Info Principal -->
            <div class="flex-1 min-w-0">
              <h1 class="text-2xl lg:text-3xl font-bold text-gray-900 mb-1 truncate">
                {{ profile.participant.firstName }} {{ profile.participant.lastName }}
              </h1>
              <div class="flex flex-wrap items-center gap-3 text-sm text-gray-500 mb-3">
                <span
                  class="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-gray-100 text-gray-700 font-medium whitespace-nowrap">
                  <svg class="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2m-7 4H9a2 2 0 01-2-2v-1a2 2 0 012-2h2.586a1 1 0 00.707-.293l2.414-2.414a1 1 0 00.707-.293H15a2 2 0 012 2v1a2 2 0 01-2 2z" />
                  </svg>
                  {{ profile.participant.typeDocument }} {{ profile.participant.documentId }}
                </span>
                <span class="flex items-center gap-1.5 hover:text-indigo-600 transition-colors cursor-pointer truncate">
                  <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span class="truncate">{{ profile.participant.email }}</span>
                </span>
                <span class="flex items-center gap-1.5 whitespace-nowrap">
                  <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  {{ profile.participant.cellPhone || profile.participant.phone }}
                </span>
              </div>
              <div class="flex items-center gap-2 flex-wrap">
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 whitespace-nowrap">
                  <span class="w-1.5 h-1.5 bg-green-500 rounded-full mr-1.5"></span>
                  Activo
                </span>
                <span class="text-xs text-gray-400 whitespace-nowrap" *ngIf="profile.participant.createdAt">
                  Registrado el {{ formatDate(profile.participant.createdAt) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex gap-3 w-full lg:w-auto flex-shrink-0">
            <button (click)="goBack()"
              class="flex-1 lg:flex-none inline-flex justify-center items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm whitespace-nowrap">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Volver
            </button>
            <button (click)="goToEdit()"
              class="flex-1 lg:flex-none inline-flex justify-center items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors shadow-sm whitespace-nowrap">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Editar Perfil
            </button>
          </div>
        </div>

        <hr class="my-6 border-gray-100">

        <!-- Financial Summary Cards -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <!-- Total Pagado -->
          <div class="p-4 rounded-xl bg-emerald-50 border border-emerald-100 transition-all hover:shadow-md">
            <div class="flex justify-between items-start mb-2">
              <div class="p-2 bg-white rounded-lg shadow-sm text-emerald-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span class="text-xs font-semibold text-emerald-700 bg-white px-2 py-0.5 rounded-full">Global</span>
            </div>
            <p class="text-sm font-medium text-emerald-800">Total Pagado</p>
            <p class="text-2xl font-bold text-emerald-900">{{ formatCurrency(profile.financialSummary.totalPaid) }}</p>
          </div>

          <!-- Pendiente -->
          <div class="p-4 rounded-xl bg-amber-50 border border-amber-100 transition-all hover:shadow-md">
            <div class="flex justify-between items-start mb-2">
              <div class="p-2 bg-white rounded-lg shadow-sm text-amber-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <p class="text-sm font-medium text-amber-800">Total Pendiente</p>
            <p class="text-2xl font-bold text-amber-900">{{ formatCurrency(profile.financialSummary.totalPending) }}</p>
          </div>

          <!-- Excedente -->
          <div class="p-4 rounded-xl bg-blue-50 border border-blue-100 transition-all hover:shadow-md">
            <div class="flex justify-between items-start mb-2">
              <div class="p-2 bg-white rounded-lg shadow-sm text-blue-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <span class="text-xs font-semibold text-blue-700 bg-white px-2 py-0.5 rounded-full"
                title="Saldo a favor">Disponible</span>
            </div>
            <p class="text-sm font-medium text-blue-800">Excedente / A Favor</p>
            <p class="text-2xl font-bold text-blue-900">{{ formatCurrency(profile.financialSummary.availableExcess) }}
            </p>
          </div>

          <!-- Balance Neto -->
          <div class="p-4 rounded-xl bg-purple-50 border border-purple-100 transition-all hover:shadow-md">
            <div class="flex justify-between items-start mb-2">
              <div class="p-2 bg-white rounded-lg shadow-sm text-purple-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                </svg>
              </div>
            </div>
            <p class="text-sm font-medium text-purple-800">Balance Neto</p>
            <p class="text-2xl font-bold text-purple-900">{{ formatCurrency(profile.financialSummary.netBalance) }}</p>
          </div>
        </div>
      </div>

      <!-- Navigation Tabs & Content -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden min-h-[500px]">

        <!-- Tab Navigation -->
        <div class="border-b border-gray-200 px-6 overflow-x-auto no-scrollbar">
          <nav class="flex space-x-8" aria-label="Tabs">
            <button (click)="setActiveTab('overview')"
              [class]="isActiveTab('overview') ? 'border-indigo-500 text-indigo-600 border-b-2' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
              class="whitespace-nowrap py-4 px-1 font-medium text-sm flex items-center gap-2 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Resumen
            </button>
            <button (click)="setActiveTab('individual-enrollments')"
              [class]="isActiveTab('individual-enrollments') ? 'border-indigo-500 text-indigo-600 border-b-2' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
              class="whitespace-nowrap py-4 px-1 font-medium text-sm flex items-center gap-2 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Individuales
              <span class="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-xs ml-1">{{
                individualEnrollments.length }}</span>
            </button>
            <button (click)="setActiveTab('corporate-enrollments')"
              [class]="isActiveTab('corporate-enrollments') ? 'border-purple-500 text-purple-600 border-b-2' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
              class="whitespace-nowrap py-4 px-1 font-medium text-sm flex items-center gap-2 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Empresariales
              <span class="bg-purple-100 text-purple-600 px-2 py-0.5 rounded-full text-xs ml-1">{{
                corporateEnrollments.length }}</span>
            </button>
            <button (click)="setActiveTab('payments')"
              [class]="isActiveTab('payments') ? 'border-indigo-500 text-indigo-600 border-b-2' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
              class="whitespace-nowrap py-4 px-1 font-medium text-sm flex items-center gap-2 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Pagos
              <span class="bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-xs ml-1">{{
                profile.incomeReceipts.length }}</span>
            </button>
            <button (click)="setActiveTab('movements')"
              [class]="isActiveTab('movements') ? 'border-indigo-500 text-indigo-600 border-b-2' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2'"
              class="whitespace-nowrap py-4 px-1 font-medium text-sm flex items-center gap-2 transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
              Otros Movimientos
            </button>
          </nav>
        </div>

        <!-- TAB CONTENT AREA -->
        <div class="p-6 md:p-8">

          <!-- TAB 1: OVERVIEW -->
          <div *ngIf="isActiveTab('overview')" class="space-y-6">
            <h3 class="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2">
              <svg class="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Información Personal Detallada
            </h3>

            <div class="bg-gray-50 rounded-xl p-6 border border-gray-100 mb-8">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-8">
                <div>
                  <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Nombre
                    Completo</label>
                  <p class="text-sm font-medium text-gray-900">{{ profile.participant.firstName }} {{
                    profile.participant.lastName }}</p>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Edad</label>
                  <p class="text-sm font-medium text-gray-900">{{ profile.participant.age }} años</p>
                </div>
                <div>
                  <label
                    class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Profesión</label>
                  <p class="text-sm font-medium text-gray-900">{{ profile.participant.profession || 'No especificada' }}
                  </p>
                </div>
                <div>
                  <label
                    class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Ubicación</label>
                  <p class="text-sm font-medium text-gray-900 flex items-center gap-1">
                    <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {{ profile.participant.city || 'No especificada' }}, {{ profile.participant.country || 'No
                    especificado' }}
                  </p>
                </div>
                <div>
                  <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Empresa</label>
                  <p class="text-sm font-medium text-gray-900">{{ profile.participant.company?.name || 'No especificada'
                    }}</p>
                </div>
                <div>
                  <label
                    class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Dirección</label>
                  <p class="text-sm font-medium text-gray-900">{{ profile.participant.addressLine1 || 'No especificada'
                    }}</p>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Reference Info -->
              <div *ngIf="profile.participant.referenceName"
                class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                <h4 class="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <svg class="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Referencia Personal
                </h4>
                <div class="space-y-3">
                  <div class="flex justify-between border-b border-gray-50 pb-2">
                    <span class="text-sm text-gray-500">Nombre</span>
                    <span class="text-sm font-medium text-gray-900">{{ profile.participant.referenceName }}</span>
                  </div>
                  <div class="flex justify-between border-b border-gray-50 pb-2">
                    <span class="text-sm text-gray-500">Parentesco</span>
                    <span class="text-sm font-medium text-gray-900">{{ profile.participant.referenceRelationship ||
                      'N/A' }}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-sm text-gray-500">Contacto</span>
                    <span class="text-sm font-medium text-gray-900">{{ profile.participant.referencePhoneNumber || 'N/A'
                      }}</span>
                  </div>
                </div>
              </div>

              <!-- Quick Stats Mini -->
              <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                <h4 class="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <svg class="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                  Estadísticas Rápidas
                </h4>
                <div class="grid grid-cols-3 gap-2 text-center">
                  <div class="p-3 bg-blue-50 rounded-lg">
                    <div class="text-xl font-bold text-blue-600">{{ profile.financialSummary.activeEnrollments }}</div>
                    <div class="text-[10px] uppercase font-bold text-blue-400 mt-1">Inscripciones</div>
                  </div>
                  <div class="p-3 bg-green-50 rounded-lg">
                    <div class="text-xl font-bold text-green-600">{{ profile.financialSummary.completedPayments }}</div>
                    <div class="text-[10px] uppercase font-bold text-green-400 mt-1">Pagos</div>
                  </div>
                  <div class="p-3 bg-purple-50 rounded-lg">
                    <div class="text-xl font-bold text-purple-600">{{ profile.financialSummary.totalTransactions }}
                    </div>
                    <div class="text-[10px] uppercase font-bold text-purple-400 mt-1">Tx Total</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB 2: INDIVIDUAL ENROLLMENTS -->
          <div *ngIf="isActiveTab('individual-enrollments')" class="space-y-6">
            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2">
                <svg class="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Inscripciones Individuales
                <span class="bg-indigo-100 text-indigo-700 px-2.5 py-0.5 rounded-full text-sm font-semibold ml-2">
                  {{ individualEnrollments.length }}
                </span>
              </h3>
            </div>

            <!-- Individual Enrollments List -->
            <div class="space-y-4">
              <div *ngIf="individualEnrollments.length === 0"
                class="py-12 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50">
                <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5z" />
                </svg>
                <p class="text-gray-500 font-medium">No hay inscripciones individuales registradas.</p>
              </div>

              <div *ngFor="let enrollment of individualEnrollments"
                class="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-indigo-200 transition-colors shadow-sm">
                <!-- Card Header -->
                <div
                  class="bg-gray-50 px-6 py-4 border-b border-gray-100 flex flex-wrap justify-between items-center gap-4">
                  <div class="flex-1 min-w-0">
                    <div class="flex items-start justify-between gap-4 mb-2">
                      <h4 class="text-lg font-bold text-gray-900 truncate">{{ enrollment.project?.name || 'Proyecto sin
                        nombre' }}</h4>
                      <a [routerLink]="['/dashboard/enrollments/view-v2', enrollment.id]" target="_blank"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-indigo-600 text-white rounded-lg text-xs font-medium hover:bg-indigo-700 transition-colors shadow-sm whitespace-nowrap flex-shrink-0">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        Ver Inscripción
                      </a>
                    </div>
                    <div class="flex items-center gap-3 flex-wrap">
                      <span
                        class="text-xs font-medium text-gray-500 bg-white border border-gray-200 px-2 py-0.5 rounded whitespace-nowrap">{{
                        enrollment.project?.projectId || 'N/A' }}</span>
                      <span
                        class="text-xs font-medium text-gray-400 bg-gray-50 border border-gray-100 px-2 py-0.5 rounded whitespace-nowrap">ID:
                        {{ enrollment.project?.id || 'N/A' }}</span>
                      <span class="text-sm text-gray-500 whitespace-nowrap">Inscrito el {{
                        formatDate(enrollment.dateEnrolled) }}</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-3 flex-shrink-0">
                    <div class="text-right mr-2 hidden sm:block">
                      <p class="text-xs text-gray-500">Progreso de Pago</p>
                      <p class="text-sm font-bold text-gray-900">
                        {{ enrollment.totalAmount > 0 ? ((enrollment.amountPaid / enrollment.totalAmount) * 100 |
                        number:'1.0-0') : 0 }}%
                      </p>
                    </div>
                    <div class="w-16 h-16 relative flex-shrink-0">
                      <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
                        <path class="text-gray-200"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                          stroke="currentColor" stroke-width="4" />
                        <path class="text-indigo-500"
                          [attr.stroke-dasharray]="(enrollment.totalAmount > 0 ? ((enrollment.amountPaid / enrollment.totalAmount) * 100) : 0) + ', 100'"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                          stroke="currentColor" stroke-width="4" />
                      </svg>
                    </div>
                    <span [class]="getPaymentStatusClass(enrollment.paymentStatus)"
                      class="px-3 py-1 rounded-full text-xs font-bold border whitespace-nowrap">
                      {{ getPaymentStatusLabel(enrollment.paymentStatus) }}
                    </span>
                  </div>
                </div>

                <!-- Card Body: Financials -->
                <div class="px-6 py-5">
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Valor Inscripción</p>
                      <p class="text-lg font-semibold text-gray-900">{{ formatCurrency(enrollment.inscriptionAmount ||
                        enrollment.totalAmount) }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Descuento</p>
                      <p class="text-lg font-semibold text-green-600">-{{ formatCurrency(enrollment.discountAmount || 0)
                        }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Total a Pagar</p>
                      <p class="text-lg font-bold text-indigo-900">{{ formatCurrency(enrollment.totalAmount) }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Saldo Pendiente</p>
                      <p class="text-lg font-bold text-amber-600">{{ formatCurrency(enrollment.remainingBalance ||
                        (enrollment.totalAmount - enrollment.amountPaid)) }}</p>
                    </div>
                  </div>

                  <!-- Mini Plan Table -->
                  <div *ngIf="enrollment.paymentPlans && enrollment.paymentPlans.length > 0"
                    class="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden mt-6">
                    <div class="px-4 py-2 bg-gray-100 border-b border-gray-200 flex justify-between items-center">
                      <h5 class="text-xs font-bold text-gray-600 uppercase">Resumen Plan de Pagos ({{
                        enrollment.installments || enrollment.paymentPlans.length }} Cuotas)</h5>
                      <a [routerLink]="['/dashboard/enrollments/view-v2', enrollment.id]" target="_blank"
                        class="text-xs text-indigo-600 hover:text-indigo-800 font-medium whitespace-nowrap">Ver detalle
                        completo →</a>
                    </div>
                    <div class="overflow-x-auto">
                      <table class="min-w-full text-sm">
                        <thead class="bg-gray-50">
                          <tr>
                            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 whitespace-nowrap">Cuota
                            </th>
                            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 whitespace-nowrap">
                              Vencimiento</th>
                            <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 whitespace-nowrap">Monto
                            </th>
                            <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 whitespace-nowrap">Pagado
                            </th>
                            <th class="px-4 py-2 text-center text-xs font-medium text-gray-500 whitespace-nowrap">Estado
                            </th>
                          </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100 bg-white">
                          <tr *ngFor="let plan of enrollment.paymentPlans" class="hover:bg-gray-50">
                            <td class="px-4 py-2 whitespace-nowrap">#{{ plan.installmentNumber }}</td>
                            <td class="px-4 py-2 text-gray-500 whitespace-nowrap">{{ formatDate(plan.dueDate) }}</td>
                            <td class="px-4 py-2 text-right font-medium whitespace-nowrap">{{
                              formatCurrency(plan.amountToPay) }}</td>
                            <td class="px-4 py-2 text-right whitespace-nowrap">
                              <span class="text-emerald-600 font-medium">{{ formatCurrency(plan.amountPaid || 0)
                                }}</span>
                            </td>
                            <td class="px-4 py-2 text-center">
                              <span *ngIf="plan.paymentStatus === 'PAID'"
                                class="w-2 h-2 rounded-full bg-green-500 inline-block" title="Pagado"></span>
                              <span *ngIf="plan.paymentStatus === 'PENDING'"
                                class="w-2 h-2 rounded-full bg-amber-500 inline-block" title="Pendiente"></span>
                              <span *ngIf="plan.paymentStatus === 'OVERDUE'"
                                class="w-2 h-2 rounded-full bg-red-500 inline-block" title="Vencido"></span>
                              <span *ngIf="plan.paymentStatus === 'PARTIALLY_PAID'"
                                class="w-2 h-2 rounded-full bg-blue-500 inline-block" title="Parcial"></span>
                              <span *ngIf="plan.paymentStatus === 'LINK_GENERATED'"
                                class="w-2 h-2 rounded-full bg-indigo-500 inline-block" title="Link Generado"></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB 3: CORPORATE ENROLLMENTS -->
          <div *ngIf="isActiveTab('corporate-enrollments')" class="space-y-6">
            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2">
                <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Inscripciones Empresariales
                <span class="bg-purple-100 text-purple-700 px-2.5 py-0.5 rounded-full text-sm font-semibold ml-2">
                  {{ corporateEnrollments.length }}
                </span>
              </h3>
            </div>

            <!-- Corporate Enrollments List -->
            <div class="space-y-4">
              <div *ngIf="corporateEnrollments.length === 0"
                class="py-12 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50">
                <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <p class="text-gray-500 font-medium">No hay inscripciones empresariales registradas.</p>
              </div>

              <div *ngFor="let enrollment of corporateEnrollments"
                class="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-purple-200 transition-colors shadow-sm">
                <!-- Card Header -->
                <div
                  class="bg-purple-50 px-6 py-4 border-b border-purple-100 flex flex-wrap justify-between items-center gap-4">
                  <div class="flex-1 min-w-0">
                    <div class="flex items-start justify-between gap-4 mb-2">
                      <div>
                        <h4 class="text-lg font-bold text-gray-900 truncate">{{ enrollment.project?.name || 'Proyecto
                          sin nombre' }}</h4>
                        <div class="flex items-center gap-2 mt-1">
                          <span
                            class="px-2 py-0.5 bg-purple-100 text-purple-800 text-xs rounded-full font-medium flex items-center gap-1">
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                            {{ enrollment.company?.name || 'Empresa' }}
                          </span>
                          <span *ngIf="enrollment.defaultCompanyCoveragePercent" class="text-xs text-gray-500">
                            Cobertura: {{ enrollment.defaultCompanyCoveragePercent }}%
                          </span>
                        </div>
                      </div>
                      <a [routerLink]="['/dashboard/enrollments/corporate/view-v2', enrollment.id]" target="_blank"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white rounded-lg text-xs font-medium hover:bg-purple-700 transition-colors shadow-sm whitespace-nowrap flex-shrink-0">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        Ver Inscripción
                      </a>
                    </div>
                    <div class="flex items-center gap-3 flex-wrap">
                      <span
                        class="text-xs font-medium text-gray-500 bg-white border border-gray-200 px-2 py-0.5 rounded whitespace-nowrap">{{
                        enrollment.project?.projectId || 'N/A' }}</span>
                      <span
                        class="text-xs font-medium text-gray-400 bg-gray-50 border border-gray-100 px-2 py-0.5 rounded whitespace-nowrap">ID:
                        {{ enrollment.project?.id || 'N/A' }}</span>
                      <span class="text-sm text-gray-500 whitespace-nowrap">Inscrito el {{
                        formatDate(enrollment.createdAt) }}</span>
                      <span class="text-xs text-gray-400">{{ enrollment.participantsCount }} participante(s) en
                        empresa</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-3 flex-shrink-0">
                    <div class="text-right mr-2 hidden sm:block">
                      <p class="text-xs text-gray-500">Progreso de Pago</p>
                      <p class="text-sm font-bold text-gray-900">
                        {{ (enrollment.completionPercentage || 0) | number:'1.0-0' }}%
                      </p>
                    </div>
                    <div class="w-16 h-16 relative flex-shrink-0">
                      <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
                        <path class="text-gray-200"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                          stroke="currentColor" stroke-width="4" />
                        <path class="text-purple-500"
                          [attr.stroke-dasharray]="(enrollment.completionPercentage || 0) + ', 100'"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none"
                          stroke="currentColor" stroke-width="4" />
                      </svg>
                    </div>
                    <span [class]="getPaymentStatusClass(enrollment.status)"
                      class="px-3 py-1 rounded-full text-xs font-bold border whitespace-nowrap">
                      {{ enrollment.status === 'active' ? 'Activa' : (enrollment.status === 'completed' ? 'Completada' :
                      (enrollment.status === 'overdue' ? 'Vencida' : enrollment.status)) }}
                    </span>
                  </div>
                </div>

                <!-- Card Body: Financials -->
                <div class="px-6 py-5">
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Total a Pagar</p>
                      <p class="text-lg font-bold text-indigo-900">{{ formatCurrency(enrollment.totalAmount) }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Pagado</p>
                      <p class="text-lg font-semibold text-green-600">{{ formatCurrency(enrollment.paidAmount) }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Pendiente</p>
                      <p class="text-lg font-bold text-amber-600">{{ formatCurrency(enrollment.pendingAmount) }}</p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500 mb-1">Vencido</p>
                      <p class="text-lg font-bold"
                        [ngClass]="{'text-red-600': enrollment.overdueAmount > 0, 'text-gray-400': !enrollment.overdueAmount}">
                        {{ formatCurrency(enrollment.overdueAmount || 0) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB 4: PAYMENTS -->
          <div *ngIf="isActiveTab('payments')" class="space-y-6">
            <div class="flex items-center justify-between mb-6">
              <h3 class="text-lg font-bold text-gray-900">Historial de Pagos Recibidos</h3>
            </div>

            <div *ngIf="profile.incomeReceipts.length === 0"
              class="py-12 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50">
              <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p class="text-gray-500 font-medium">No hay pagos registrados.</p>
            </div>

            <div *ngIf="profile.incomeReceipts.length > 0"
              class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col"
                      class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Referencia</th>
                    <th scope="col"
                      class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Fecha
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Concepto
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Método
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Monto
                    </th>
                    <th scope="col"
                      class="px-6 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Acción
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr *ngFor="let receipt of profile.incomeReceipts" class="hover:bg-gray-50 transition-colors">
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">#{{ receipt.referenceNumber
                      || receipt.transactionId || receipt.id }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(receipt.transactionDate
                      || receipt.createdAt) }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <div class="font-medium">{{ receipt.concept }}</div>
                      <div class="text-xs text-gray-500">{{ receipt.project?.name || 'N/A' }}</div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <span
                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-700">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        {{ receipt.paymentMethod?.name || 'N/A' }}
                      </span>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-right font-bold text-emerald-600">{{
                      formatCurrency(receipt.grossAmount || receipt.netAmount) }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                      <a [routerLink]="['/income-receipts/view', receipt.id]" target="_blank"
                        class="text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 p-2 rounded-full transition-colors inline-block"
                        title="Ver Recibo">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- TAB 5: MOVEMENTS -->
          <div *ngIf="isActiveTab('movements')" class="space-y-8">

            <!-- Excess Payments -->
            <div *ngIf="profile.excessPayments.length > 0">
              <h4 class="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                <div class="p-1.5 bg-blue-100 rounded text-blue-600">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                Pagos Excedentes
              </h4>
              <div class="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-blue-50/50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-blue-800 uppercase">Fecha</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-blue-800 uppercase">Proyecto</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-blue-800 uppercase">Monto Original</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-blue-800 uppercase">Disponible</th>
                      <th class="px-6 py-3 text-center text-xs font-medium text-blue-800 uppercase">Estado</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr *ngFor="let excess of profile.excessPayments" class="hover:bg-gray-50">
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(excess.excessDate) }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ excess.project?.name || 'N/A' }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">{{
                        formatCurrency(excess.excessAmount) }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-right font-bold text-green-600">{{
                        formatCurrency(excess.availableAmount) }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-center">
                        <span [class]="getStatusClass(excess.status)"
                          class="px-2 py-1 text-xs font-medium rounded-full">
                          {{ excess.status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Refund Vouchers -->
            <div *ngIf="profile.refundVouchers.length > 0">
              <h4 class="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                <div class="p-1.5 bg-green-100 rounded text-green-600">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </div>
                Vouchers de Devolución
              </h4>
              <div class="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-green-50/50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase">Número Documento</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase">Fecha</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase">Concepto</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-green-800 uppercase">Monto</th>
                      <th class="px-6 py-3 text-center text-xs font-medium text-green-800 uppercase">Estado</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr *ngFor="let refund of profile.refundVouchers" class="hover:bg-gray-50">
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ refund.documentNumber }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(refund.documentDate)
                        }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ refund.refundConcept }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-right font-medium text-gray-900">{{
                        formatCurrency(refund.refundAmount) }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-center">
                        <span [class]="getStatusClass(refund.status)"
                          class="px-2 py-1 text-xs font-medium rounded-full">
                          {{ refund.status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Credit Notes -->
            <div *ngIf="profile.creditNotes.length > 0">
              <h4 class="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                <div class="p-1.5 bg-purple-100 rounded text-purple-600">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                Notas de Crédito
              </h4>
              <div class="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-purple-50/50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-purple-800 uppercase">Número</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-purple-800 uppercase">Fecha</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-purple-800 uppercase">Concepto</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-purple-800 uppercase">Monto</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr *ngFor="let credit of profile.creditNotes" class="hover:bg-gray-50">
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ credit.noteNumber }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(credit.noteDate) }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ credit.concept }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-right font-medium text-purple-600">{{
                        formatCurrency(credit.amount) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Debit Notes -->
            <div *ngIf="profile.debitNotes.length > 0">
              <h4 class="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
                <div class="p-1.5 bg-red-100 rounded text-red-600">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                  </svg>
                </div>
                Notas de Débito
              </h4>
              <div class="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-red-50/50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-red-800 uppercase">Número</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-red-800 uppercase">Fecha</th>
                      <th class="px-6 py-3 text-left text-xs font-medium text-red-800 uppercase">Concepto</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-red-800 uppercase">Monto</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr *ngFor="let debit of profile.debitNotes" class="hover:bg-gray-50">
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ debit.noteNumber }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(debit.noteDate) }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ debit.concept }}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-right font-medium text-red-600">{{
                        formatCurrency(debit.amount) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Empty State -->
            <div
              *ngIf="profile.excessPayments.length === 0 && profile.refundVouchers.length === 0 && profile.creditNotes.length === 0 && profile.debitNotes.length === 0"
              class="py-12 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50">
              <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
              <p class="text-gray-500 font-medium">No hay otros movimientos financieros registrados</p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && !profile" class="text-center py-20">
      <svg class="w-16 h-16 text-red-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <h2 class="text-xl font-semibold text-gray-900 mb-2">Error al cargar el perfil</h2>
      <p class="text-gray-600 mb-4">No se pudo cargar la información del participante</p>
      <button (click)="goBack()" class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
        Volver al listado
      </button>
    </div>

  </main>
</div>